/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-card[_ngcontent-%COMP%]{height:230px;margin:20px;float:left;width:80%}@media (min-width:600px){mat-card[_ngcontent-%COMP%]{width:300px}}mat-card-title[_ngcontent-%COMP%]{height:50px}mat-card-content[_ngcontent-%COMP%]{padding-top:20px}mat-card-content.course[_ngcontent-%COMP%]{display:flex}.spinner[_ngcontent-%COMP%]{display:inline-block;padding-left:20px}.thumbnail[_ngcontent-%COMP%]{flex:1 0 100px}.description[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{margin-bottom:10px}.no-access[_ngcontent-%COMP%]{padding-left:20px}"];
export { styles as styles };
